export const SORT_OPTIONS = {
  DAYS_LEFT: 'daysLeft',
  TIME_ZONE: 'timeZone',
  DAYS_SINCE_COLLECTION: 'daysSinceCollection',
  UNITED_STATES: 'unitedStates',
}
